import ElementUI, { Message } from "element-ui"

export {
  Message
}

export default ElementUI
